import React, { useState } from "react";
import styles from "./style.module.css";
import { ErrorMessage, Form, Formik } from "formik";
import { Button, Container, Label } from "semantic-ui-react";
import { toast } from "react-toastify";
import PinInput from "react-pin-input";
import { Alert } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Loading from "../../../../../app/layout/Loading";
import Modal from "../../../../../app/common/modals/Custom";
import { useStore } from "../../../../../app/stores/store";
import { authSchema } from "../../../../../app/validation/validationSchema";
import { InputTemp } from "../../../../../app/common/form/Custom";
import { observer } from "mobx-react-lite";

const VendorForgotPassword = (props: any) => {
  const { nextStep, setInputField, inputField } = props;
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [page, setPage] = useState("home");
  const initialValues = { emailAddress: "", phoneNumber: "" };
  const [activeModal, setActiveModal] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpData, setOtpData] = useState("");
  const navigateToLogin = () => {
    navigate({ pathname: "/vendor/login" });
  };
  const { userStore, commonStore } = useStore();
  const { forgotPassword, verifyOtp, loginStatus } = userStore;

  const [modalResInfo, setModalResInfo] = useState<{
    status: boolean | null;
    message: string;
  }>({
    status: null,
    message: "",
  });
  const clearError = () => {
    setModalResInfo({
      status: null,
      message: "",
    });
  };
  const handleForgotPassword = async (values: any) => {
    clearError();
    await forgotPassword(values.email)
      .then((res) => {
        if (res.responseCode === "00") {
          setOtpData(res.data);
          setActiveModal(true);
        } else {toast.error(res.responseMessage)};
      })
      .catch((error) =>
        setModalResInfo({
          status: true,
          message: "Problem Completing Request",
        })
      );
  };

  const handleOtpVerification = async () => {
    verifyOtp({ otp: otp, phoneNumber: otpData })
      .then((res) => {
        if (res.responseCode === "00") {
          nextStep();
        } else if (res.responseCode === "99") {
          setModalResInfo({
            status: true,
            message: res.responseMessage,
          });
        }
      })
      .catch((error) =>
        setModalResInfo({
          status: true,
          message: "Problem Validating Otp",
        })
      );
  };
  // console.log(activeModal);
  return (
    <Container height="70%">
      {loginStatus === "loading" && <Loading />}
      {activeModal && (
        <Modal
          variant="unstyled"
          style={{ position: "fixed", zIndex: "2" }}
          openModal={true}
          closeModal={() => setActiveModal(false)}
        >
          <div className={styles.requestOtp}>
            <h2>User Verification</h2>
            {/* <h3>0123456789 - Beatrice Bimpe</h3> */}
            <p>Enter the OTP sent to your email or Phone Number</p>
            <PinInput
              autoSelect={true}
              length={6}
              initialValue=""
              onChange={(x) => setOtp(x)}
            />
            <div className={styles.otpError}>
              {modalResInfo.status && (
                <Alert variant="danger" onClose={clearError} dismissible>
                  <p>{modalResInfo.message}</p>
                </Alert>
              )}
            </div>
            <div className={styles.btnOtpModal}>
              <Button
                positive
                // className={styles.positive}
                disabled={otp.length !== 6}
                type="submit"
                content="Submit"
                loading={loginStatus === "loading"}
                onClick={() => {
                  handleOtpVerification();
                  // setActiveModal("");
                  clearError();
                }}
              />
            </div>
          </div>
        </Modal>
      )}
      <Formik
        initialValues={initialValues}
        validationSchema={authSchema.forgotPassword}
        onSubmit={handleForgotPassword}
      >
        {({
          dirty,
          handleSubmit,
          getFieldProps,
          setFieldValue,
          errors,
          isValid,
          isSubmitting,
          setSubmitting,
          touched,
          values,
        }) => (
          <Form onSubmit={handleSubmit}>
            <div className={styles.container}>
              <h3>Forgot Password?</h3>
              <p>Please enter your registered email address</p>
              <InputTemp
                placeholder="email@host.co.."
                // name="emailAddress"
                inputType="email"
                // value={values.emailAddress}
                // {...getFieldProps("emailAddress")}
                onChange={(e) => {
                  setFieldValue("email", e.target.value);
                  setInputField({
                    ...inputField,
                    email: e.target.value,
                  });
                }}
              />
              <div style={{ width: "100%" }}>
                <ErrorMessage
                  name={"emailAddress"}
                  render={(error) => (
                    <Label basic color="red" content={error} />
                  )}
                />
              </div>
              <div className={styles.flexbtwn}>
                <Button
                  type="button"
                  content={`Back`}
                  width="37%"
                  className={styles.back}
                  onClick={navigateToLogin}
                />
                <Button
                  content="Submit"
                  positive
                  className={styles.positive}
                  variant="primary"
                  disabled={loginStatus === "loading" || !dirty || !isValid}
                  width="58%"
                  type="submit"
                />
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </Container>
  );
};

export default observer(VendorForgotPassword);
